namespace Areas.Dialogs.EditAccountCIBCost {
    "use strict";

    export const calculations = new Calculations();

    let baseURL = "/Dialog/EditAccountCIBCost";
    let accountCIBId: any;

    export class EditAccountCIBCostDialog extends Areas.BaseDialog {
        protected grid: any;

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("EditAccountCIBCost",
                closeHandler,
                parameters,
                () => {
                    this.grid = $("#EditAccountDIBCostGrid").dxDataGrid("instance");
                    let url = `${baseURL}/AccountCIBCost`;
                    accountCIBId = parameters.accountCIBId;

                    $.get(`${url}/${accountCIBId}`,
                        (data) => {
                            this.grid.option("dataSource", calculations.transformData(data));
                        });
                    }
                );
        }

        protected ok = (e: any) => {
            if (this.grid.hasEditData()) {
                // delaying call to get data from grid
                // otherwise if user edits a cell value and immediately clicks
                // on the OK (save) button without exiting the cell
                // the data in the grid may not be updated yet
                setTimeout(() => {
                   this.saveModifiedData();
                }, 500);
            } else {
                this.close(DialogResult.Ok, null);
            }
        }

        saveModifiedData() {
            let modifiedData = this.getModifiedData();

            sendRequest(`${baseURL}/AccountCIBCostPost/${accountCIBId}`,
                JSON.stringify(modifiedData),
                "POST",
                () => {
                    this.close(DialogResult.Ok, null);
                });
        }

        getModifiedData() {
            const budgets = ["c1", "c2", "c3"];
            const computedKeys = ["SubTotal", "PWCTotal", "ProjectTotal", "GrandTotal"];

            let modifiedData = {
                "accountCIBId": accountCIBId
            };

            const modifiedRows = this.grid.getVisibleRows().filter((x: any) => x.modified && !computedKeys.includes(x.key));

            modifiedRows.forEach((modifiedRow: any) => {
                let modifiedValues = modifiedRow.modifiedValues;
                let data = modifiedRow.data;

                for (let index = 0; index < modifiedValues.length; index++) {
                    const modifiedValue = modifiedValues[index];

                    if (typeof modifiedValue !== 'undefined') {
                        const budget = budgets[index-1];
                        const propertyName = budget + data.key;

                        modifiedData[propertyName] = modifiedValue;
                    }
                }
            });

            return modifiedData;
        }
    }
}
